import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { fileUrl } from "@/lib/api";
import { embedUrl } from "@/lib/media";
import { useVideoUrl } from "@/lib/useVideoUrl";

// Plays an uploaded video, a YouTube/Facebook link, or shows a photo full size.
export const MediaView = ({ kind, url: raw, title }) => {
  const url = useVideoUrl(kind === "video" ? raw : "") || raw;
  const embed = kind === "video" ? embedUrl(url) : "";
  if (embed) return <iframe data-testid="media-view-embed" src={embed} title={title || "Video"} allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen className="aspect-video w-full rounded-xl bg-black" />;
  if (kind === "video") return <video data-testid="media-view-video" src={fileUrl(url)} controls autoPlay playsInline className="max-h-[75vh] w-full rounded-xl bg-black" />;
  return <img data-testid="media-view-photo" src={fileUrl(url)} alt={title || ""} className="max-h-[78vh] w-full rounded-xl object-contain" />;
};

export const MediaDialog = ({ item, onClose, title, caption }) => (
  <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="media-dialog" className="max-w-5xl border-[#D4AF37]/20 bg-[#0B111E] p-3 text-[#F4EEE2] sm:p-5">
      <DialogTitle className="sr-only">{title || "Media"}</DialogTitle>
      {item && <MediaView kind={item.kind} url={item.url} title={title} />}
      {(title || caption) && (
        <div className="px-1 pt-2">
          {title && <p data-testid="media-dialog-title" className="font-display text-2xl font-semibold">{title}</p>}
          {caption && <p className="mt-1 font-ui text-xs uppercase tracking-[0.2em] text-[#B7BFCC]">{caption}</p>}
        </div>
      )}
    </DialogContent>
  </Dialog>
);
